import Form from 'components/Form';
import MuiTextField from 'components/Form/MuiTextField';
import RowContainer from '../../components/RowContainer';
import RowContent from '../../components/RowContent';
import SubRowContent from './RowContent';

import { IPatientInfo } from 'apis/admin/type';
import { IFormRegister } from 'routes/Main/type';

interface Props extends IFormRegister {
  disabled?: boolean;
  nurseName: string;
  patientInfo: IPatientInfo;
}

const PatientStaffInfo = (props: Props) => {
  const {
    patientInfo: {
      patient_id,
      name,
      age,
      gender,
      ward,
      room,
      admin_hod,
      department,
      disease_main,
      main_doctor,
      height,
      weight,
      blood,
    },
    register,
    disabled,
  } = props;

  const infos = [
    { title: '病人姓名', value: name },
    { title: '登记号码', value: patient_id },
    { title: '年龄', value: age },
    { title: '性别', value: gender },
    { title: '病房', value: ward },
    { title: '房间', value: room },
    { title: '科室', value: department },
    { title: '科主任', value: admin_hod },
    { title: '身高', value: height },
    { title: '体重', value: weight },
    { title: '血型', value: blood },
    { title: '诊断', value: disease_main.disease_eng },
  ];

  const staffs = [
    {
      title: '主刀医生',
      variable: 'surgery_information.operating_surgeon',
    },
    {
      title: '助手',
      variable: 'surgery_information.assistant',
    },
    {
      title: '洗手护士',
      variable: 'surgery_information.scrubbing_nurse',
    },
    {
      title: '巡回护士',
      variable: 'surgery_information.circulating_nurse',
    },
  ];

  return (
    <RowContainer xs={12}>
      {infos.map(({ title, value }) =>
        title === '性别' ? (
          <RowContent title={title} titleRatio={1} childrenRatio={2}>
            <Form.MuiRadioGroup
              i18nKey="GENDER"
              values={[1, 2]}
              value={Number(value)}
              defaultValue={Number(value)}
            />
          </RowContent>
        ) : (
          <RowContent title={title} titleRatio={1} childrenRatio={2}>
            <Form.MuiTextField value={value} InputProps={{ readOnly: true }} />
          </RowContent>
        )
      )}

      {staffs.map(({ title, variable }, _) => {
        return (
          <RowContent
            key={variable}
            title={title}
            titleRatio={1}
            childrenRatio={2}
          >
            <MuiTextField
              {...register(variable)}
              required={false}
              disabled={disabled}
            />
          </RowContent>
        );
      })}
    </RowContainer>
  );
};

export default PatientStaffInfo;
